import { Badge, BadgeProps, makeStyles } from '@fluentui/react-components';
import { TApprovalPhaseKey } from '@modules/approvals';

/**
 * Maps approval role to badge color and display label.
 */
const getRoleBadgeProps = (phase: TApprovalPhaseKey): { color: BadgeProps['color']; label: string } => {
  switch (phase) {
    case 'AUTHORING':
      return { color: 'informative', label: 'Author' };
    case 'REVIEWING':
      return { color: 'warning', label: 'Reviewer' };
    case 'APPROVING':
      return { color: 'brand', label: 'Approver' };
    default:
      return { color: 'informative', label: phase };
  }
};

const useStyles = makeStyles({
  root: {
    fontWeight: 'normal',
  },
});

type TProps = {
  phase: TApprovalPhaseKey;
};

const RoleBadge = ({ phase }: TProps) => {
  const { color, label } = getRoleBadgeProps(phase);
  const classes = useStyles();

  return (
    <Badge color={color} appearance="tint" size="large" className={classes.root}>
      {label}
    </Badge>
  );
};

export default RoleBadge;
